export type SolicitacaoStatus = 'EM_ANALISE' | 'APROVADA' | 'EM_ANDAMENTO' | 'CONCLUIDA' | 'RECUSADA' | 'CANCELADA';
export type SolicitacaoCategoria = 'SUGESTAO' | 'AJUSTE' | 'ERRO' | 'NOVA_FUNCIONALIDADE';
export type SolicitacaoPrioridade = 'BAIXA' | 'MEDIA' | 'ALTA';

export interface SolicitacaoAnexo {
	id: string;
	name: string;
	mimetype: string;
	size: number;
	uploadedBy: string | null;
	createdAt: string;
}

export interface SolicitacaoHistorico {
	id: string;
	fromStatus: SolicitacaoStatus | null;
	toStatus: SolicitacaoStatus;
	note: string | null;
	userName: string | null;
	userEmail: string | null;
	createdAt: string;
}

export interface Solicitacao {
	id: string;
	number: number;
	title: string;
	description: string;
	category: SolicitacaoCategoria;
	priority: SolicitacaoPrioridade;
	area: string | null;
	siteName: string | null;
	status: SolicitacaoStatus;
	queueRank: number | null;
	estimatedDate: string | null;
	adminResponse: string | null;
	releaseVersion: string | null;
	requesterEmail: string | null;
	requesterName: string | null;
	statusChangedAt: string;
	completedAt: string | null;
	createdAt: string;
	attachmentCount?: number;
	attachments?: SolicitacaoAnexo[];
	history?: SolicitacaoHistorico[];
}

export interface SolicitacaoComentario {
	id: string;
	comment: string;
	userName: string | null;
	userEmail: string | null;
	createdAt: string;
}

export interface SolicitacoesMe {
	isAdmin: boolean;
	email: string | null;
}

export const STATUS_INFO: Record<SolicitacaoStatus, { label: string; classes: string; dot: string }> = {
	EM_ANALISE: { label: 'Em análise', classes: 'bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-200', dot: 'bg-amber-500' },
	APROVADA: { label: 'Aprovada', classes: 'bg-blue-100 text-blue-800 dark:bg-blue-500/20 dark:text-blue-200', dot: 'bg-blue-500' },
	EM_ANDAMENTO: { label: 'Em andamento', classes: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-500/20 dark:text-indigo-200', dot: 'bg-indigo-500' },
	CONCLUIDA: { label: 'Concluída', classes: 'bg-green-100 text-green-800 dark:bg-green-500/20 dark:text-green-200', dot: 'bg-green-500' },
	RECUSADA: { label: 'Recusada', classes: 'bg-red-100 text-red-800 dark:bg-red-500/20 dark:text-red-200', dot: 'bg-red-500' },
	CANCELADA: { label: 'Cancelada', classes: 'bg-gray-100 text-gray-700 dark:bg-gray-500/20 dark:text-gray-300', dot: 'bg-gray-400' },
};

export const CATEGORIA_LABEL: Record<SolicitacaoCategoria, string> = {
	SUGESTAO: 'Sugestão',
	AJUSTE: 'Ajuste',
	ERRO: 'Erro',
	NOVA_FUNCIONALIDADE: 'Nova funcionalidade',
};

export const PRIORIDADE_LABEL: Record<SolicitacaoPrioridade, string> = {
	BAIXA: 'Baixa',
	MEDIA: 'Média',
	ALTA: 'Alta',
};

/** Igual ao backend (customer-request.rules.ts). */
export const MAX_ANEXOS_POR_ENVIO = 5;
export const MAX_ANEXO_BYTES = 10 * 1024 * 1024;
export const ANEXOS_ACEITOS = 'image/*,video/mp4,video/webm,video/quicktime,application/pdf,text/csv,.xlsx,.xls,.docx';
